import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { FaGithub, FaDesktop } from "react-icons/fa";
import RenderIf from '../../../components/RenderIf';
import { portifolio } from '../../../constants';
import { ContainerImgPortifolio, DivStyleWidth, FlexContainerGridImages, Li, MenuPortifolio, SSection } from '../../../styles/pages/Home';
import theme from '../../../styles/theme';

type DataType = typeof portifolio;

type ItemMenuType = {
    text: string,
    active: boolean,
    onClick: () => void
}

const ItemMenu = ({ text, active, onClick }: ItemMenuType) => {
    return (
        <Li
            active={active}
            onClick={onClick}
        >
            {text}
        </Li>
    )
}

const Portifolio: React.FC = () => {

    const [items, setItems] = useState({ indexMenu: 1, data: portifolio });

    const filter = (type: 'web' | 'mobile', data: DataType, index: number) => {
        const newItems = data.filter((item) => {
            return item.type === type;
        })

        setItems({ indexMenu: index, data: newItems });
    }


    return (
        <SSection backgroundcolor={theme.colors.background} id='portifolio'>
            <div className='container'>
                <h1>Portifólio</h1>
                <span className="sub-title">Meus Projetos</span>
                <MenuPortifolio>
                    <ul>
                        <ItemMenu
                            onClick={() => setItems({ indexMenu: 1, data: portifolio })}
                            text='Todos'
                            active={items.indexMenu === 1 ? true : false}
                        />
                        <ItemMenu
                            onClick={() => filter('web', portifolio, 2)}
                            text='Web App'
                            active={items.indexMenu === 2 ? true : false}
                        />
                        <ItemMenu
                            onClick={() => filter('mobile', portifolio, 3)}
                            text='Mobile App'
                            active={items.indexMenu === 3 ? true : false}
                        />
                    </ul>
                </MenuPortifolio>
                <DivStyleWidth>
                    <FlexContainerGridImages layout >
                        <AnimatePresence>
                            {items.data.map((data, index) => (
                                <ContainerImgPortifolio
                                    key={index}
                                    layout
                                    animate={{ opacity: 1, scale: 1 }}
                                    initial={{ opacity: 0, scale: 0 }}
                                    exit={{ opacity: 0, scale: 0 }}
                                >
                                    <div className='img' >
                                        <img src={data.img} alt="img" />
                                    </div>

                                    <div className='blackScreen'>
                                        <div>
                                            <a href={data.gitHub} target="_blank" rel="noreferrer"  >
                                                <button>
                                                    <FaGithub size={15} />
                                                    Repositório
                                                </button>
                                            </a>
                                            <RenderIf isTrue={data.demonstration ? true : false}>
                                                <a href={data.demonstration} target="_blank" rel="noreferrer" >
                                                    <button>
                                                        <FaDesktop size={15} />
                                                        Demostração
                                                    </button>
                                                </a>
                                            </RenderIf>
                                        </div>
                                        <div>
                                            <h3>
                                                {data.name}
                                            </h3>

                                            <RenderIf isTrue={data.link ? true : false}>
                                                <a href={data.link} target='_blank' rel="noreferrer"  >
                                                    Design da Behance
                                                </a>
                                            </RenderIf>
                                        </div>
                                    </div>

                                </ContainerImgPortifolio>
                            ))}
                        </AnimatePresence>

                    </FlexContainerGridImages>
                </DivStyleWidth>

            </div>

        </SSection>
    );
}

export default Portifolio;